export enum MODAL_MODE {
  CHAT_LIST = 'cl',
  REQUEST_CHAT_LIST = 'rcl',
  NEW_CHAT = 'nc',
  NEW_GROUP_CHAT = 'ngc',
  CHAT_ROOM = 'cr',
  CHAT_ROOM_DETAIL = 'crd',
  REPORT = 'rp',
  CREATE_USER_REVIEW = 'cur',
  GROUP_INVITATION = 'gi',
  GROUP_BAN_LIST = 'gbl',
  GROUP_MUTE_LIST = 'gml',
  CREATE_GROUP = 'cg',
  FOLLOW_REQUEST = 'fr',
  GROUP_JOIN_REQUEST = 'gjr',
  GROUP_MEMBER = 'gm',
  GROUP_SETTINGS = 'gs',
  GROUPS_SETTINGS = 'gss',
  GROUP_MODERATORS = 'gmo',
  GROUP_TRANSFER_OWNERSHIP = 'gto',
  GROUP_IN_CIRCLE_RANKING = 'gicr',
  MAINTENANCE = 'mtn',
  HIMANOW_USER_LIST = 'hul',
  SEND_GIFT_MODAL = 'sgm',
  PURCHASE_EMPL = 'buy_empl',
  POSTBOX_MODAL = 'pbm',
  USER_FOLLOWER = 'uf',
  USER_REVIEW_LIST = 'url',
  USER_EDIT = 'ue',
  FOLLOWING_LIST = 'fl',
  ACTIVITY_USERS_BIRTHDAY = 'aub',
  CALL_LIST_MODAL = 'clm',
  SELECT_CATEGORY = 'sc',
  SELECT_CALL_SETTINGS = 'scs',
  TIMELINE_FILTER = 'tf',
  RELATED_GROUPS = 'rg',
  ADD_RELATED_GROUPS = 'arg',
  MUTE_KEYWORDS = 'mkw',
  KEYWORD_DETAILS = 'kwd',
  LOGIN = 'login',
  SIGN_UP = 'sign_up',
  SIGN_UP_FORM = 'sign_up_form',
  INTERESTS_SELECTION = 'is',
  EXISTING_THREADS = 'et',
  USER_AGREEMENT = 'ua',
  ACTIVITY_SETTINGS = 'as',
  TRANSACTION_DETAILS = 'trd',
  GIFT_EXCHANGE_TRANSACTION_DETAILS = 'gxt',
  EMPL_AGREEMENT = 'empl_a',
}
